import type { FC, ReactNode } from "react";
import { guaranteeHighlightItemRecipe, guaranteeHighlightsContainer } from "./styles";
import type { GuaranteeHighlightData } from "./types";

const renderHighlightTile = (data: GuaranteeHighlightData): ReactNode => {
  const { row, textContainer, iconContainer, titleText, descriptionText } = guaranteeHighlightItemRecipe({
    descriptionVisibility: data.qualifier ? "shown" : "hidden",
  });

  return (
    <div key={data.analyticsItemId} className={row}>
      <div className={iconContainer}>{data.icon}</div>
      <div className={textContainer}>
        <div className={titleText}>{data.messageText}</div>
        {data.qualifier ? <div className={descriptionText}>{data.qualifier}</div> : null}
      </div>
    </div>
  );
};

interface Props {
  highlights: GuaranteeHighlightData[];
}

/**
 * Renders FanProtect + Resell Anytime guarantee tiles in the same
 * layout as the event-page highlights grid.
 */
export const GuaranteeHighlights: FC<Props> = ({ highlights }) => {
  if (highlights.length === 0) return null;
  return <div className={guaranteeHighlightsContainer}>{highlights.map((data) => renderHighlightTile(data))}</div>;
};
